import { Component, OnInit, Input, ElementRef, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'app-notification',
	templateUrl: './notification.component.html',
	styleUrls: ['./notification.component.scss']
})
export class INDRANotificationComponent implements OnInit {
	@Input()
	style: 'information' | 'success' | 'alert' | 'error' | 'note' = 'information';

	@Input()
	icon;

	@Input()
	title;

	@Input()
	titleKey;

	@Input()
	classes;


	@Input()
	close = false;

	@Output() closeNotif = new EventEmitter<boolean>();

	constructor(
		private elementRef: ElementRef
	) {	}

	ngOnInit() {}

	INDRA_printStyle() {
		return {
			'notification--information': this.style === 'information',
			'notification--success': this.style === 'success',
			'notification--alert': this.style === 'alert',
			'notification--error': this.style === 'error',
			'notification--note': this.style === 'note',
			'no-icon': this.icon === undefined,
			'has-close': this.close
		};
	}

	INDRA_close() {
		this.elementRef.nativeElement.remove();
		this.closeNotif.emit(true);
	}

	INDRA_printIcon() {
		return this.icon;
	}

	INDRA_printTitle() {
		return this.title;
	}
}
